<template>
  <div class="box">
    <div id="app-home">
      <div class="container">
        <div class="goback">
          <div @click="goback">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
        </div>
        <div class="content">
          <div class="fild_label ">
            <span>*</span>
            <div>给TA点个赞</div>
          </div>
          <div class="fild_value">
            <el-select
              v-model="valuePeople"
              placeholder="请输入赠送名字"
              clearable
              filterable
              remote
              :remote-method="changeOption"
              :loading="loadingSelect"
              ref="select"
              @blur.native.capture="onblur"
              @hook:mounted="cancalReadOnly"
              @visible-change="cancalReadOnly"
              @change="handleChange"
            >
              <el-option
                v-for="item in optionPeople"
                :key="item.workcode"
                :label="item.orgname + '-' + item.name"
                :value="item.workcode"
                :disabled="!['1211', '1212', '1217'].includes(String(item.EmpType)) || String(item.EmpRank) === '1738'"
              >
              </el-option>
            </el-select>
          </div>
          <div class="fild_label fild_label2">
            <span>*</span>
            <div>捕捉TA的闪光点</div>
          </div>
          <div class="fild_value">
            <el-select
              v-model="valueMoney"
              placeholder="请选择"
              @change="changeValueMoney"
            >
              <el-option
                v-for="item in optionMoney"
                :key="item.id"
                :label="item.medalName"
                :value="item.id"
              >
                <span style="float: left">{{ item.medalName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.point||0 }}分</span>
              </el-option>
            </el-select>
          </div>
          <div class="message">
            {{ remarks }}
          </div>
          <div class="fild_label fild_label2">
            <span>*</span>
            <div>细数TA的名场面</div>
          </div>
          <div class="fild_value">
            <van-field
              v-model="message"
              rows="4"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="在什么工作/项目中，TA做了什么值得被点赞?展开说说，20-200字"
              show-word-limit
              @change="handleMessage"
            />
          </div>
          <div class="fild_label3">
            <div class="label_left">
              <span>*</span>
              <div>这份认可，想让TA也看见</div>
            </div>
            <div class="label_right">
              <img
                src="../../../assets/newMedal/kkq/add.svg"
                alt=""
                @click="addClick"
              />
            </div>
          </div>
          <!-- 标签只展示头像+文字，可删除项显示删除按钮 -->
          <div class="fild_tag">
            <div class="tags" v-for="(item, idx) in tagList" :key="idx">
              <img :src="item.icon" alt="" />
              <div>{{ item.nickname }}</div>
              <span
                v-if="item.deletable !== false"
                class="tag-close"
                @click="removeTag(idx)"
              >×</span>
            </div>
          </div>
        </div>
        <div class="submit">
          <el-button @click="handleSubmit" :disabled="isBtnDisabled">
            确认
          </el-button>
        </div>
      </div>
      <depamentDialog
        :visible.sync="depamentDialog"
        @changeQuery="changeQuery"
        :userNames="userNames"
      />
    </div>
  </div>
</template>
<script>
import api from "@/apis/medal";
import depamentDialog from "./depamentDialog.vue";
import { getToken } from "@/utils/cookie";
export default {
  name: "quaquaka",
  components: {
    depamentDialog,
  },
  data() {
    return {
      optionMoney: [],
      valueMoney: "",
      valuePeople: "", // 赠送人
      optionPeople: [],
      loadingSelect: false,
      message: "",
      depamentDialog: false,
      userNames: [],
      tagList: [],
      remarks: "",
      kuakuaReason: "",
      isBtnDisabled: false,
      empno: "",
      list: [],
      id: "",
      bossWorkcode: "", // 上级工号（不可删除）
    };
  },
  created() {},
  mounted() {
    this.queryClassification();
    const { id } = this.$route.query;
    let token = window.sessionStorage.hrToken;
    let hrToken = getToken();
    if (token) {
      this.empno = hrToken;
      if (!id) {
        this.medalCardNewReceived();
      }
    } else {
      this.$bus.$on("processToken", (res) => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
          if (!id) {
            this.medalCardNewReceived();
          }
        });
      });
    }
  },
  methods: {
    //赠送 夸夸列表
    medalCardNewReceived() {
      api
        .medalCardLstApi({
          page: 1,
          pageSize: 2000,
          empno: this.empno,
          hrAuthToken: window.sessionStorage.hrToken,
        })
        .then((res) => {
          if (res.code == 200) {
            this.list = res.data;
            if (this.list.length > 0) {
              this.id = this.list[0].id;
            } else {
              this.id = "";
              this.$message({
                type: "warning",
                message: "您已无赠送机会",
                duration: 2000,
              });
            }
          }
        });
    },
    //返回上一页
    goback() {
      this.$router.go(-1);
    },
    //获取赠与人
    changeOption(value) {
      this.loadingSelect = true;
      api
        .quaGetEmployeeInfo({
          name: value,
        })
        .then((data) => {
          this.optionPeople = data.data;
          this.loadingSelect = false;
        });
    },
    //获取弹框高度
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    //选择赠与人
    handleChange() {
      this.queryParentName();
    },
    // 根据工号查询上级：置顶且不可删除；更换赠与人时先移除旧上级
    queryParentName() {
      api.queryParentNameApi({ userName: this.valuePeople }).then((res) => {
        if (res.code == 200) {
          if (this.valuePeople) {
            // 1. 移除旧的上级（只保留一个，且始终在第一位）
            this.tagList = this.tagList.filter(
              (item) => item.deletable !== false
            );
            // 2. 新的上级置顶、标记不可删除
            const bossItem = { ...res.data, deletable: false };
            this.tagList.unshift(bossItem);
            this.bossWorkcode = bossItem.workcode;
          } else {
            // 清空赠与人时，仅移除上级，保留可删除的抄送人
            this.tagList = this.tagList.filter(
              (item) => item.deletable !== false
            );
            this.bossWorkcode = "";
          }
        }
      });
    },
    //打开抄选人弹窗
    addClick() {
      this.userNames = this.tagList;
      this.$nextTick(() => {
        this.depamentDialog = true;
      });
    },
    //弹窗回调（保留不可删除的上级，新抄送人标记为可删除）
    changeQuery(val) {
      // 上级：始终取自当前 tagList 中的不可删除项（赠与人带出的那个）
      const bossItem = this.tagList.find((item) => item.deletable === false);
      // 抄送人：统一标记可删除，并排除上级（上级由 bossItem 单独管理）
      const ccList = val
        .map((item) => ({ ...item, deletable: true }))
        .filter((item) => item.username !== (bossItem && bossItem.username));
      // 按 username 去重，避免重复添加同一抄送人
      const seen = new Set();
      const deduped = ccList.filter((item) => {
        if (seen.has(item.username)) return false;
        seen.add(item.username);
        return true;
      });
      // 上级永远在第一个，抄送人跟在后面
      this.tagList = bossItem ? [bossItem, ...deduped] : deduped;
      console.log(this.tagList, "this.tagList");
    },
    //删除抄送人（仅可删除项）
    removeTag(idx) {
      const item = this.tagList[idx]
      if (!item || item.deletable === false) return
      this.tagList.splice(idx, 1)
    },
    //获取价值观列表
    queryClassification() {
      let rtitle = JSON.parse(localStorage.getItem("store")).userInfo.rtitle;
      api.queryClassificationApi({ cardType: 1, rtitle }).then((data) => {
        this.optionMoney = data.data;
      });
    },
    //改变价值观
    changeValueMoney(value) {
      const info = this.optionMoney.filter((item) => item.id === value);
      this.remarks = info[0].remarks;
    },
    //提交
    handleSubmit() {
      if (!this.valueMoney) {
        return this.$message({
          type: "warning",
          message: "请选择价值观",
          duration: 2000,
        });
      }
      if (!this.valuePeople) {
        return this.$message({
          type: "warning",
          message: "请选择赠与人",
          duration: 2000,
        });
      }
      if (!this.message) {
        return this.$message({
          type: "warning",
          message: "请输入夸夸理由",
          duration: 2000,
        });
      }
      if (this.message.length < 20) {
        return this.$message({
          type: "warning",
          message: "夸夸理由最少需要20个字",
          duration: 2000,
        });
      }
      if (this.tagList.length == 0) {
        return this.$message({
          type: "warning",
          message: "请选择抄送人",
          duration: 2000,
        });
      }
      // 判断this.kuakuaReason中必须包含文字
      if (!this.message || !/[\u4e00-\u9fa5]/.test(this.message)) {
        return this.$message.warning("夸夸理由必须包含文字哦");
      }
      const valueList = this.tagList.map((item) => {
        return item.username;
      });
      const json = {
        medalId: this.valueMoney,
        receiverEmpno: this.valuePeople,
        ccEmpno: valueList.join(","),
        reason: this.kuakuaReason,
        senderEmpno: this.$store.state.userInfo.username,
        cardId: this.$route.query.id ? this.$route.query.id : this.id,
      };
      console.log(json, "json");
      this.isBtnDisabled = true;
      api
        .medalCardSendApi(json)
        .then((res) => {
          if (res.code == 200) {
            this.showTip = false;
            this.$message({
              message: "赠送成功",
              type: "success",
            });
            this.$router.back();
          }
          this.isBtnDisabled = false;
        })
        .catch(() => {
          this.isBtnDisabled = false;
        });
    },
    //将字符串转换为base64编码
    handleMessage() {
      this.kuakuaReason = this.stringToBase64(this.message);
    },
    //将字符串转换为base64编码
    stringToBase64(str) {
      // 将字符串转换为 UTF-8 编码的二进制数据
      const encoder = new TextEncoder();
      const uint8Array = encoder.encode(str);
      // 将二进制数据转换为 Base64 编码
      const base64String = btoa(String.fromCharCode.apply(null, uint8Array));
      return base64String;
    },
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
}
@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
}
.box {
  width: 100%;
  display: flex;
  justify-content: center;
}
.container {
  padding: 30px;
  .content {
    width: 100%;
    height: 77.1vh;
    border-radius: 40px;
    background: #fff;
    overflow: auto;
    padding: 40px;
    &::-webkit-scrollbar {
      display: none;
    }
    .fild_label {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      span {
        color: #ff4d4d;
        margin-right: 5px;
        font-size: 32px;
      }
      div {
        color: #0a1629;
        font-weight: bold;
        font-size: 32px;
      }
    }
    .fild_label2 {
      margin-top: 40px;
    }
    .fild_label3 {
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      margin-bottom: 20px;
      .label_left {
        display: flex;
        align-items: flex-start;
        div {
          color: #0a1629;
          font-weight: bold;
          font-size: 32px;
        }
      }
      span {
        color: #ff4d4d;
        margin-right: 5px;
        font-size: 32px;
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
    .fild_value {
      width: 100%;
      ::v-deep {
        .el-input {
          width: 100%;
        }
        .el-select {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          height: 80px;
          border-radius: 16px;
          background: #fafafa;
          border: none;
        }
        .van-cell {
          border-radius: 16px;
          background: #fafafa;
        }
      }
    }
    .fild_tag {
      font-size: 28px;
      color: #999999;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .tags {
        width: 150px;
        text-align: center;
        margin-bottom: 15px;
        position: relative;
        div {
          text-align: center;
        }
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-bottom: 10px;
          text-align: center;
        }
        // 删除按钮（圆形红色背景 ×）
        .tag-close {
          position: absolute;
          top: -6px;
          right: 35px;
          width: 32px;
          height: 32px;
          line-height: 30px;
          border-radius: 50%;
          background: #ff4d4d;
          color: #fff;
          font-size: 24px;
          text-align: center;
          cursor: pointer;
          border: 2px solid #fff;
        }
      }
    }
    .message {
      font-size: 26px;
      color: #969b9e;
      line-height: 38px;
      margin-top: 20px;
    }
  }
}
.submit {
  margin-top: 4vh;
  ::v-deep {
    .el-button {
      width: 100%;
      height: 80px;
      background: #1fbe8a;
      color: #fff;
      font-size: 32px;
      border-radius: 16px;
    }
  }
}
.goback {
  margin: 10px 40px 40px 10px;
  display: flex;
  align-items: center;
  div {
    display: flex;
    align-items: center;
  }
  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }
  span {
    font-size: 34px;
  }
  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    width: 58vw;
    padding: 0 30px 0 10px;
    align-items: center;
    justify-content: space-between;
    ::v-deep .el-input {
      flex: 1;
      height: 100%;
      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }
    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
</style>
